
export default class Storage {

	constructor(){
		this.localStorage = window.localStorage
	}

	setItem(key,value=''){
		this.localStorage.setItem(key,value)
		return value
	}

	getItem(key){

		let value = this.localStorage.getItem(key)
		if(value == '') return null
		if(typeof value == 'undefined') return null

		return value;

	}

	clear(key=null){
		this.localStorage.clear()
	}
	
}

 
